import React, { useRef, useState, useEffect } from 'react'
import SCMultipleChoiceText from '../SCInteractComponents/SCMultipleChoiceText'
import SCMultiDropdown from '../SCInteractComponents/SCMultiDropdown'
import SCTrueFalseComponent from '../SCInteractComponents/SCTrueFalseComponent'
import SCMultipleAnswer from '../SCInteractComponents/SCMultipleAnswer'
import SCMultiInput from '../SCInteractComponents/SCMultiInput'
import SCRearrange from '../SCInteractComponents/SCRearrange'
import { SketchPad } from './SketchPad'
import { KnovaImage } from '../BasicUIComponents/KnovaImage'
import SCRTEComponent from '../SCInteractComponents/SCRTEComponent'
import CanvasDrawing from '../UIUtilsFiles/CanvasDrawing/CanvasDrawing'
import SCVideoComponent from '../SCInteractComponents/SCVideoComponent'
import SCAnswerPad from '../SCInteractComponents/SCAnswerPad'
import ScrollableCanvas from '../UIUtilsFiles/CanvasDrawing/ScrollableCanvas'

function AssessmentComponents(props) {
  const {
    isPractice,
    Completed,
    isActive,
    themeProperties,
    assesmentBlockData,
    isSideMenu,
    componentDefaultValue,
    isOutsideClick,
    isFollowTheFlow,
    priorityActive,
    isClassroom,
    isAudioPlaying,
    isMinimize
  } = props
  const {
    InkJson,
    strokeColor,
    strokeReplayStarted,
    sketchType,
    strokeWidth,
    currentSpeed,
    getStrokeReplayFinished,
    getCurrentRectangleData,
    getReplyStatus,
    isReplaying
  } = props //Replay rectangles variables
  const {
    handleValueChange,
    getCurrentSelectedOption,
    onPriorityChange,
    handleSucAndFailFeedback,
    onToastTrigger,
    onVideoControlChange,
    handleSelectionStatus
  } = props

  const parentRef = useRef(null)

  function renderImage(assesmentFullData) {
    if (assesmentFullData.IsVideo) {
      return (
        <SCVideoComponent
          componentData={assesmentFullData}
          onVideoControlChange={onVideoControlChange}
        />
      )
    } else {
      return (
        <KnovaImage imgSource={assesmentFullData.Url} objectFit='contain' />
      )
    }
  }

  function renderAssesmentBlock() {
    if (assesmentBlockData && assesmentBlockData.PluginName) {
      return (
        <div
          className='layout-full-cont'
          style={{
            paddingBottom:
              assesmentBlockData.PluginName === 'SCAnswerPad' ? '20px' : '0px',
            pointerEvents: isAudioPlaying || isReplaying ? 'none' : 'auto'
          }}
        >
          {assesmentBlockData.PluginName === 'Dropdown' ? (
            <SCMultiDropdown
              isPractice={isPractice}
              Completed={Completed}
              isActive={isActive}
              componentData={assesmentBlockData}
              themeColors={themeProperties.themeColors}
              themeFont={themeProperties.themeFont}
              isSideMenu={isSideMenu}
              defaultValue={componentDefaultValue}
              layoutType={10}
              isOutsideClick={isOutsideClick}
              isFollowTheFlow={isFollowTheFlow}
              priorityActive={priorityActive}
              onValueChange={handleValueChange}
              getCurrentSelectedOption={(data) => {
                getCurrentSelectedOption(data)
              }}
              onPriorityChange={onPriorityChange}
              handleSucAndFailFeedback={handleSucAndFailFeedback}
              isAudioPlaying={isAudioPlaying}
              isMinimize={isMinimize}
              isReplaying={isReplaying}
            />
          ) : assesmentBlockData.PluginName === 'SCTrueFalse' ? (
            <SCTrueFalseComponent
              isPractice={isPractice}
              Completed={Completed}
              isActive={isActive}
              componentData={assesmentBlockData}
              themeColors={themeProperties.themeColors}
              themeFont={themeProperties.themeFont}
              themeStyles={themeProperties.themeStyles}
              isSideMenu={isSideMenu}
              isFollowTheFlow={isFollowTheFlow}
              priorityActive={priorityActive}
              defaultValue={componentDefaultValue}
              onValueChange={handleValueChange}
              onPriorityChange={onPriorityChange}
              handleSucAndFailFeedback={handleSucAndFailFeedback}
              isAudioPlaying={isAudioPlaying}
              isMinimize={isMinimize}
              isReplaying={isReplaying}
            />
          ) : assesmentBlockData.PluginName === 'SCMultipleAnswer' ? (
            <SCMultipleAnswer
              isPractice={isPractice}
              Completed={Completed}
              isActive={isActive}
              componentData={assesmentBlockData}
              themeColors={themeProperties.themeColors}
              themeFont={themeProperties.themeFont}
              themeStyles={themeProperties.themeStyles}
              isSideMenu={isSideMenu}
              isFollowTheFlow={isFollowTheFlow}
              priorityActive={priorityActive}
              defaultValue={componentDefaultValue}
              onValueChange={handleValueChange}
              onPriorityChange={onPriorityChange}
              handleSucAndFailFeedback={handleSucAndFailFeedback}
              isAudioPlaying={isAudioPlaying}
              isReplaying={isReplaying}
            />
          ) : assesmentBlockData.PluginName === 'InputAnswer' ? (
            <SCMultiInput
              isPractice={isPractice}
              Completed={Completed}
              isActive={isActive}
              componentData={assesmentBlockData}
              themeColors={themeProperties.themeColors}
              themeFont={themeProperties.themeFont}
              isSideMenu={isSideMenu}
              isFollowTheFlow={isFollowTheFlow}
              priorityActive={priorityActive}
              defaultValue={componentDefaultValue}
              layoutType={10}
              isOutsideClick={isOutsideClick}
              onValueChange={handleValueChange}
              getCurrentSelectedOption={(data) => {
                getCurrentSelectedOption(data)
              }}
              onPriorityChange={onPriorityChange}
              handleSucAndFailFeedback={handleSucAndFailFeedback}
              isAudioPlaying={isAudioPlaying}
              isMinimize={isMinimize}
              isReplaying={isReplaying}
            />
          ) : assesmentBlockData.PluginName === 'SCArrangeOrder' ? (
            <SCRearrange
              isPractice={isPractice}
              Completed={Completed}
              isActive={isActive}
              componentData={assesmentBlockData}
              themeColors={themeProperties.themeColors}
              themeFont={themeProperties.themeFont}
              themeStyles={themeProperties.themeStyles}
              isSideMenu={isSideMenu}
              isFollowTheFlow={isFollowTheFlow}
              priorityActive={priorityActive}
              defaultValue={componentDefaultValue}
              onValueChange={handleValueChange}
              onPriorityChange={onPriorityChange}
              handleSucAndFailFeedback={handleSucAndFailFeedback}
              isAudioPlaying={isAudioPlaying}
              isReplaying={isReplaying}
            />
          ) : assesmentBlockData.PluginName === 'SCAnswerPad' ? (
            <SCAnswerPad
              isPractice={isPractice}
              Completed={Completed}
              isActive={isActive}
              componentData={assesmentBlockData}
              themeColors={themeProperties.themeColors}
              themeFont={themeProperties.themeFont}
              themeStyles={themeProperties.themeStyles}
              isSideMenu={isSideMenu}
              isFollowTheFlow={isFollowTheFlow}
              priorityActive={priorityActive}
              defaultValue={componentDefaultValue}
              onValueChange={handleValueChange}
              onPriorityChange={onPriorityChange}
              handleSucAndFailFeedback={handleSucAndFailFeedback}
              currentSpeed={currentSpeed}
              strokeReplayStarted={strokeReplayStarted}
              getStrokeReplayFinished={getStrokeReplayFinished}
              onToastTrigger={onToastTrigger}
              isClassroom={isClassroom}
              isReplaying={isReplaying}
            />
          ) : (
            // <ScrollableCanvas />
            <SCMultipleChoiceText
              isPractice={isPractice}
              Completed={Completed}
              isActive={isActive}
              componentData={assesmentBlockData}
              themeColors={themeProperties.themeColors}
              themeFont={themeProperties.themeFont}
              themeStyles={themeProperties.themeStyles}
              isSideMenu={isSideMenu}
              isFollowTheFlow={isFollowTheFlow}
              priorityActive={priorityActive}
              defaultValue={componentDefaultValue}
              onValueChange={handleValueChange}
              onPriorityChange={onPriorityChange}
              handleSucAndFailFeedback={handleSucAndFailFeedback}
              isAudioPlaying={isAudioPlaying}
              isReplaying={isReplaying}
              handleSelectionStatus={handleSelectionStatus}
            />
          )}
        </div>
      )
    } else if (assesmentBlockData && assesmentBlockData.PluginId) {
      return (
        <div
          className='layout-full-cont'
          style={{
            pointerEvents: isAudioPlaying || isReplaying ? 'none' : 'auto'
          }}
        >
          {assesmentBlockData.PluginId === 'SCHotspotImages' ? (
            renderImage(assesmentBlockData)
          ) : (
            <div
              className='sketch-pad-area'
              style={{
                paddingBottom: isSideMenu ? '2px' : '20px',
                pointerEvents:
                  isAudioPlaying || isReplaying || Completed === 1 || !isActive
                    ? 'none'
                    : 'auto'
              }}
            >
              <SCRTEComponent
                fromLayout={true}
                componentData={assesmentBlockData}
                themeColors={themeProperties.themeColors}
                themeFont={themeProperties.themeFont}
                isSideMenu={isSideMenu}
                defaultValue={componentDefaultValue}
                onValueChange={handleValueChange}
              />
            </div>
          )}
        </div>
      )
    } else {
      return (
        <div
          ref={parentRef}
          className='sketch-pad-area'
          style={{
            paddingBottom: isSideMenu ? '2px' : '20px',
            filter: isFollowTheFlow
              ? assesmentBlockData.Priority <= priorityActive
                ? 'unset'
                : 'blur(3px)'
              : 'unset'
          }}
        >
          <CanvasDrawing
            fromLayout={true}
            isSideMenu={isSideMenu}
            parentRef={parentRef}
            initialData={InkJson}
            themeColors={themeProperties.themeColors}
            onSaveData={(updatedStrokes, updatedActions) => {
              if (updatedActions.length > 0) {
                getCurrentRectangleData(
                  assesmentBlockData.ControlID,
                  assesmentBlockData.BoxPosition,
                  updatedStrokes,
                  updatedActions
                )
              }
            }}
            strokeStyle={strokeColor}
            lineWidth={strokeWidth}
            currentShape={sketchType}
            currentSpeed={currentSpeed}
            strokeReplayStarted={strokeReplayStarted}
            getStrokeReplayFinished={getStrokeReplayFinished}
            onToastTrigger={onToastTrigger}
            themeFont={themeProperties.themeFont}
            getReplyStatus={getReplyStatus}
            disableWriting={
              isAudioPlaying || Completed === 1 || !isActive
                ? true
                : isFollowTheFlow
                ? assesmentBlockData.Priority >= priorityActive
                  ? true
                  : false
                : false
            }
          />
        </div>
      )
    }
  }

  return (
    <div
      className='layout-full-cont'
      style={{ pointerEvents: isSideMenu ? 'none' : 'auto' }}
    >
      {renderAssesmentBlock()}
    </div>
  )
}
export default AssessmentComponents
